export default __webpack_public_path__ + "static/media/SHINE.9d2b2bf5.mp3";